import { Fragment } from "react";
import { FaPhoneFlip } from "react-icons/fa6";

function AgentPhoneNumbers({ item }) {
  if (!(item.showMobileInList || item.showOrganizationMobileInList)) {
    return <Fragment></Fragment>;
  }

  return (
    <div className="w-100 mt-4 me-3">
      <FaPhoneFlip
        style={{
          width: 25,
          height: 25,
          color: "#ff6600",
        }}
      />

      {item.showMobileInList === 1 && (
        <span style={{ marginRight: 30 }}>{item.mobile}</span>
      )}

      {item.showOrganizationMobileInList === 1 && (
        <span style={{ marginRight: 15 }}>{item.organizationMobile}</span>
      )}
    </div>
  );
}

export default AgentPhoneNumbers;
